<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/targetSplit' }">目标拆分</el-breadcrumb-item>
        <el-breadcrumb-item>目标拆分详情/考核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="innerBox content">
      <!-- <el-divider><span style="font-size: 18px;color: #666666">详情</span></el-divider> -->
      <div style="width: 80%;margin: auto">
        <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">基础信息</span></el-divider></div>
        <div class="detailBox">
          <div>
            目标指标编号：
            <span>{{ obj.indicatorNumber }}</span>
          </div>
          <div>
            类型：
            <span>{{ typeList[obj.type] }}</span>
          </div>
          <div>
            年度：
            <span>{{ obj.year }}</span>
          </div>
          <!-- <div>
            指标级别：
            <span>{{ levelList[obj.companyLeaderEmpid - 1] }}</span>
          </div> -->
          <div>
            完成期限：
            <span>{{ obj.year }}</span>
          </div>
          <div>
            制定人部门：
            <span>{{ obj.dutyDepName }}</span>
          </div>
          <div>
            制定人：
            <span>{{ obj.producer }}</span>
          </div>
          <div>
            考核时间：
            <span>{{ obj.creationTime | timeFilter }}</span>
          </div>
          <div>
            考核标准：
            <span>{{ obj.creationTime | timeFilter }}</span>
          </div>
        </div>
        <div class="tableBox">
          <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">考核内容</span></el-divider></div>
          <div class="a" style="margin-top: 30px">
            内&emsp;&emsp;容：
            <span><pre>{{ obj.objectiveExplain }}</pre></span>
          </div>
          <div class="a">
            项&emsp;&emsp;目：
            <span><pre>{{ obj.objectiveContent }}</pre></span>
          </div>
          <div class="a">
            完成时间：
            <span><pre>{{ obj.completionDate }}</pre></span>
          </div>
        </div>
        <!-- 审批流程 -->
        <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">审批流程</span></el-divider></div>
        <el-steps :active="obj.status" align-center>
          <el-step>
            <h4 slot="title">制定人</h4>
            <!-- <div slot="description" v-if="obj.status > 0"> -->
            <div slot="description">
              <div>{{ obj.creationTime }}</div>
              <div>{{ obj.producer }}</div>
              <div>发起审核</div>
              <div>{{ obj.producerExplain }}</div>
            </div>
          </el-step>
          <el-step>
            <h4 slot="title">部门审批</h4>
            <!-- <div slot="description" v-if="obj.status > 1"> -->
            <div slot="description">
              <div>{{ obj.depAuditTime }}</div>
              <div>{{ obj.departmentHeadName }}</div>
              <div v-if="obj.depAuditStatus === 0" style="color: #E6A23C">通过</div>
              <div v-if="obj.depAuditStatus === 1" style="color: red">不通过</div>
              <div>{{ obj.departmentHeadAudit }}</div>
            </div>
          </el-step>
          <el-step>
            <h4 slot="title">责任人审批</h4>
            <!-- <div slot="description" v-if="obj.status > 2"> -->
            <div slot="description">
              <div>{{ obj.dutyPersonAuditTime }}</div>
              <div>{{ obj.dutyDepName }}</div>
              <div v-if="obj.dutyPersonAuditStatus === 0" style="color: #E6A23C">通过</div>
              <div v-if="obj.dutyPersonAuditStatus === 1" style="color: red">不通过</div>
              <div>{{ obj.dutyPersonAudit }}</div>
            </div>
          </el-step>
        </el-steps>
        <el-divider />
        <el-form :model="form" label-width="90px" v-if="(obj.producerUserId == userId && obj.status === 0) || (obj.departmentHeadId == userId && obj.status === 1)
          || (obj.dutyPersonUserid == userId && obj.status === 2)">
          <el-form-item label="是否通过" v-if="obj.status !== 0">
            <el-radio-group v-model="form.pass" size="small">
              <el-radio-button :label="0">通过</el-radio-button>
              <el-radio-button :label="1">不通过</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批意见">
            <el-input type="textarea" :rows="2" v-model="form.auditContent" />
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="examineSplit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { splitInfo, examineSplit } from "@/api/processManager";
export default {
  name: "standardDetail",
  data() {
    return {
      userId: '',
      obj: {},
      tableData: [],
      typeList: ['年度目标','季度目标','月度目标'],
      levelList: ['公司级','部门级'],
      form: {
        id: '',
        pass: 0,
        auditContent: ''
      },
    };
  },
  created() {
    this.userId = localStorage.getItem('userId');
    console.log(this.userId)
    this.form.id = this.$route.params.id
    this.getDetail();
  },
  methods: {
    getDetail() {
      splitInfo(this.$route.params.id).then(res => {
        this.obj = res.body.data;
      });
    },
    // 审核
    examineSplit() {
      examineSplit({ ...this.form }).then(res => {
        this.getDetail();
        this.form.pass = 0;
        this.form.auditContent = ''
      })
    }
  }
};
</script>

<style scoped>
.detailBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.detailBox div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox > div > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
.innerBox .el-form-item {
  margin-bottom: 5px;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px
}
</style>